import { Directive, Input, inject } from '@angular/core'
import {
  ElderEnumTranslationService,
  ElderSelectComponent,
  TranslatedEnumValue,
} from '@elderbyte/ngx-starter'
import { PackageConfirmationState } from '../package'

@Directive({
  selector: '[appPackageStateSelect]',
})
export class PackageStateSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const enumTranslationService = inject(ElderEnumTranslationService)
    this.select.displayProperty = 'displayValue'
    this.select.placeholder = '-'
    this.select.dataSource = enumTranslationService.enumDataSource(
      PackageConfirmationState,
      'packages.confirmationState',
      false
    )
  }
}
